'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function windowed(arr, size) {
    var step = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_partialWindows = _ref.partialWindows, partialWindows = _ref_partialWindows === void 0 ? false : _ref_partialWindows;
    if (size <= 0 || !Number.isInteger(size)) {
        throw new Error('Size must be a positive integer.');
    }
    if (step <= 0 || !Number.isInteger(step)) {
        throw new Error('Step must be a positive integer.');
    }
    var result = [];
    var end = partialWindows ? arr.length : arr.length - size + 1;
    for(var i = 0; i < end; i += step){
        result.push(arr.slice(i, i + size));
    }
    return result;
}
exports.windowed = windowed;
